import {Grid} from "@mui/system";
import pxToRem from "hooks/usePxToRem";
import {
  VoyageDestinationField,
  VoyageOriginField,
  VoyageVesselField,
  VoyageFlightField,
  VoyageETDField,
  VoyageLoadField,
  VoyageETAField,
  VoyageUnloadField,
  VoyagePlacePickupField,
  VoyagePlaceDeliveryField,
  VoyageTypeServiceField,
  VoyageDTATransportCompany,
} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/fields";
import VoyageBindingDateField from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/fields/VoyageBindingDateField";
import VoyageGrantDateField from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/fields/VoyageGrantDateField";
import VoyageObservations from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/fields/VoyageObservations";
import {useVoyageFieldVisibility} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/hooks/useVoyageFieldVisibility";
import VoyageVisibility from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/Layout/VoyageVisibility";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";

type Props = {
  voyage: Voyage & {idForm: string};
  index: number;
  isAiProcess: boolean;
  getVoyageEditIsDisabled: () => boolean;
  allVoyages: Voyage[];
};

const VoyageFields = (props: Props) => {
  const {voyage, index, isAiProcess, getVoyageEditIsDisabled, allVoyages} =
    props;
  const {getFieldsVisibility} = useVoyageFieldVisibility(isAiProcess);

  return (
    <Grid
      container
      columnSpacing={pxToRem(8)}
      rowSpacing={pxToRem(12)}
      mb={pxToRem(8)}
      key={`${voyage.idForm}voyages`}
    >
      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).origin}
      >
        <VoyageOriginField
          index={index}
          disabled={getVoyageEditIsDisabled()}
          voyage={voyage}
          allVoyages={allVoyages}
          isAiProcess={isAiProcess}
        />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).destination}
      >
        <VoyageDestinationField
          index={index}
          disabled={getVoyageEditIsDisabled()}
          voyage={voyage}
          allVoyages={allVoyages}
          isAiProcess={isAiProcess}
        />
      </VoyageVisibility>

      {!isAiProcess && (
        <VoyageVisibility
          config={getFieldsVisibility(voyage.typeVoyage?.id).vessel}
        >
          <VoyageVesselField
            index={index}
            disabled={getVoyageEditIsDisabled()}
          />
        </VoyageVisibility>
      )}

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).voyageFlight}
      >
        <VoyageFlightField index={index} disabled={getVoyageEditIsDisabled()} />
      </VoyageVisibility>

      <VoyageVisibility config={getFieldsVisibility(voyage.typeVoyage?.id).etd}>
        <VoyageETDField index={index} disabled={getVoyageEditIsDisabled()} />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).cargoLoad}
      >
        <VoyageLoadField
          index={index}
          disabled={getVoyageEditIsDisabled()}
          allVoyages={allVoyages}
        />
      </VoyageVisibility>

      <VoyageVisibility config={getFieldsVisibility(voyage.typeVoyage?.id).eta}>
        <VoyageETAField index={index} disabled={getVoyageEditIsDisabled()} />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).cargoUnload}
      >
        <VoyageUnloadField
          index={index}
          disabled={getVoyageEditIsDisabled()}
          allVoyages={allVoyages}
        />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).placePickup}
      >
        <VoyagePlacePickupField
          index={index}
          disabled={getVoyageEditIsDisabled()}
        />
      </VoyageVisibility>

      {isAiProcess && (
        <VoyageVisibility
          config={
            getFieldsVisibility(allVoyages?.[index]?.typeVoyage?.id).bindingDate
          }
        >
          <VoyageBindingDateField
            index={index}
            disabled={getVoyageEditIsDisabled()}
          />
        </VoyageVisibility>
      )}

      {isAiProcess && (
        <VoyageVisibility
          config={
            getFieldsVisibility(allVoyages?.[index]?.typeVoyage?.id).grantDate
          }
        >
          <VoyageGrantDateField
            index={index}
            disabled={getVoyageEditIsDisabled()}
          />
        </VoyageVisibility>
      )}

      {isAiProcess && (
        <VoyageVisibility
          config={getFieldsVisibility(voyage.typeVoyage?.id).typeService}
        >
          <VoyageTypeServiceField
            index={index}
            disabled={getVoyageEditIsDisabled()}
          />
        </VoyageVisibility>
      )}

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).placeDelivery}
      >
        <VoyagePlaceDeliveryField
          index={index}
          disabled={getVoyageEditIsDisabled()}
        />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).transportCompany}
      >
        <VoyageDTATransportCompany
          index={index}
          disabled={getVoyageEditIsDisabled()}
        />
      </VoyageVisibility>

      <VoyageVisibility
        config={getFieldsVisibility(voyage.typeVoyage?.id).placeDelivery}
      >
        <VoyageObservations
          index={index}
          disabled={getVoyageEditIsDisabled()}
        />
      </VoyageVisibility>
    </Grid>
  );
};

export default VoyageFields;
